<mat-card class="ft-component-error">
    <div style="display: flex; flex-direction: row; flex-wrap: wrap; place-content: center flex-start;align-content: center">
        <span class="material-icons">error</span>
        <p *ngIf='componentDefinition.errorMessage'>{{componentDefinition.errorMessage}}</p>
    </div>
</mat-card>
